module.exports = {"pathContext":{"name":"CensusPlacementAction","kind":"ENUM","type":"OBJECT","fields":null,"description":"What is being proposed, which decides what counts as warning about itself.","enumValues":[{"deprecationReason":null,"description":"Put a patient physically into the kennel. Requires `patientId`.","isDeprecated":false,"name":"PLACE_PATIENT"},{"deprecationReason":null,"description":"Book the kennel for an appointment. Requires `appointmentId`.","isDeprecated":false,"name":"RESERVE_APPOINTMENT"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-census-placement-action.json
// module id = 1222
// module chunks = 240036240442609